import { post } from './api';

const CLIENT_ID = 'facilita-app';

const createAuthenticatedSession = ({ clientId = CLIENT_ID, temporaryId } = {}) =>
    post({
        type: 'user',
        service: 'support-chat/embed-session',
        data: { clientId, temporaryId }
    }).then(result => result.data);

const createAnonymousSession = ({ clientId = CLIENT_ID, name, email, phone, temporaryId, verificationId, code, deviceToken } = {}) =>
    post({
        type: 'user',
        service: 'support-chat/embed-session/anonymous',
        data: { clientId, name, email, phone, temporaryId, verificationId, code, deviceToken }
    }).then(result => result.data);

const createAnonymousVerification = ({ clientId = CLIENT_ID, name, email, phone, temporaryId } = {}) =>
    post({
        type: 'user',
        service: 'support-chat/embed-session/anonymous/verification',
        data: { clientId, name, email, phone, temporaryId }
    }).then(result => result.data);

const supportChatEmbedService = {
    CLIENT_ID,
    createAuthenticatedSession,
    createAnonymousVerification,
    createAnonymousSession
}

export default supportChatEmbedService;
